import request from '../utils/request'

/**
 * 获取当前用户消息。
 * msgType：0 全部、1 系统通知、2 交易通知、6 文章、7 公告。
 */
export const getMyMsgCenten = (msgType, pageNum, pageSize, hideLoad = 10) => request({
  method: 'GET',
  url: '/msg/getMyMsgCenten',
  params: { msgType, pageNum, pageSize, hideLoad }
})

/** 获取指定分类的未读消息数量。 */
export const getUnreadMsgCount = (msgType, hideLoad = 10) => request({
  method: 'GET',
  url: '/msg/getUnreadMsgCount',
  params: { msgType, hideLoad }
})

/** 全部消息设为已读。 */
export const setReadState = () => request({
  method: 'GET',
  url: '/msg/setReadState'
})

/** 读取消息详情；原接口会同步该消息的已读状态。 */
export const getMsgById = msgId => request({
  method: 'GET',
  url: '/msg/getMsgById',
  params: { msgId }
})
